module.exports = __webpack_public_path__ + "static/media/10.c7bf5e1c.mp3";